import { LdoJsonldContext } from "@ldo/ldo";

/**
 * =============================================================================
 * spoty_ldoContext: JSONLD Context for spoty_ldo
 * =============================================================================
 */
export const spoty_ldoContext: LdoJsonldContext = {
  type: {
    "@id": "@type",
    "@isCollection": true,
  },
  Sentence: {
    "@id": "https://w3id.org/SpOTy/ontology#Sentence",
    "@context": {
      type: {
        "@id": "@type",
        "@isCollection": true,
      },
      identifier: {
        "@id": "https://schema.org/identifier",
        "@type": "http://www.w3.org/2001/XMLSchema#string",
      },
      language: {
        "@id": "https://w3id.org/SpOTy/ontology#language",
        "@type": "@id",
      },
      extractedFrom: {
        "@id": "https://w3id.org/SpOTy/ontology#extractedFrom",
        "@type": "http://www.w3.org/2001/XMLSchema#string",
      },
      transcription: {
        "@id": "https://w3id.org/SpOTy/ontology#transcription",
        "@type": "http://www.w3.org/2001/XMLSchema#string",
      },
      orthography: {
        "@id": "https://w3id.org/SpOTy/ontology#orthography",
        "@type": "http://www.w3.org/1999/02/22-rdf-syntax-ns#langString",
      },
      translation: {
        "@id": "https://w3id.org/SpOTy/ontology#translation",
        "@type": "http://www.w3.org/1999/02/22-rdf-syntax-ns#langString",
      },
      source: {
        "@id": "https://w3id.org/SpOTy/ontology#source",
        "@type": "http://www.w3.org/2001/XMLSchema#string",
      },
      trajectoiresId: {
        "@id": "https://w3id.org/SpOTy/ontology#trajectoiresId",
        "@type": "http://www.w3.org/2001/XMLSchema#integer",
      },
      firstToken: {
        "@id": "https://w3id.org/SpOTy/ontology#firstToken",
        "@type": "@id",
      },
      lastToken: {
        "@id": "https://w3id.org/SpOTy/ontology#lastToken",
        "@type": "@id",
      },
    },
  },
  identifier: {
    "@id": "https://schema.org/identifier",
    "@type": "http://www.w3.org/2001/XMLSchema#string",
  },
  language: {
    "@id": "https://w3id.org/SpOTy/ontology#language",
    "@type": "@id",
  },
  P220: {
    "@id": "http://www.wikidata.org/prop/direct/P220",
    "@type": "http://www.w3.org/2001/XMLSchema#string",
    "@isCollection": true,
  },
  label: {
    "@id": "http://www.w3.org/2000/01/rdf-schema#label",
    "@type": "http://www.w3.org/1999/02/22-rdf-syntax-ns#langString",
  },
  macroarea: {
    "@id": "https://w3id.org/SpOTy/ontology#macroarea",
    "@type": "http://www.w3.org/2001/XMLSchema#string",
  },
  genus: {
    "@id": "https://w3id.org/SpOTy/ontology#genus",
    "@type": "http://www.w3.org/2001/XMLSchema#string",
  },
  phylum: {
    "@id": "https://w3id.org/SpOTy/ontology#phylum",
    "@type": "http://www.w3.org/2001/XMLSchema#string",
  },
  center: {
    "@id": "https://w3id.org/SpOTy/ontology#center",
    "@type": "@id",
  },
  longitude: {
    "@id": "https://schema.org/longitude",
    "@type": "http://www.w3.org/2001/XMLSchema#string",
  },
  latitude: {
    "@id": "https://schema.org/latitude",
    "@type": "http://www.w3.org/2001/XMLSchema#string",
  },
  orderSvo: {
    "@id": "https://w3id.org/SpOTy/ontology#order_svo",
    "@type": "http://www.w3.org/2001/XMLSchema#string",
  },
  adpositions: {
    "@id": "https://w3id.org/SpOTy/ontology#adpositions",
    "@type": "http://www.w3.org/2001/XMLSchema#string",
  },
  svc: {
    "@id": "https://w3id.org/SpOTy/ontology#svc",
    "@type": "http://www.w3.org/2001/XMLSchema#string",
  },
  extractedFrom: {
    "@id": "https://w3id.org/SpOTy/ontology#extractedFrom",
    "@type": "http://www.w3.org/2001/XMLSchema#string",
  },
  transcription: {
    "@id": "https://w3id.org/SpOTy/ontology#transcription",
    "@type": "http://www.w3.org/2001/XMLSchema#string",
  },
  orthography: {
    "@id": "https://w3id.org/SpOTy/ontology#orthography",
    "@type": "http://www.w3.org/1999/02/22-rdf-syntax-ns#langString",
  },
  translation: {
    "@id": "https://w3id.org/SpOTy/ontology#translation",
    "@type": "http://www.w3.org/1999/02/22-rdf-syntax-ns#langString",
  },
  source: {
    "@id": "https://w3id.org/SpOTy/ontology#source",
    "@type": "http://www.w3.org/2001/XMLSchema#string",
  },
  trajectoiresId: {
    "@id": "https://w3id.org/SpOTy/ontology#trajectoiresId",
    "@type": "http://www.w3.org/2001/XMLSchema#integer",
  },
  firstToken: {
    "@id": "https://w3id.org/SpOTy/ontology#firstToken",
    "@type": "@id",
  },
  Token: {
    "@id": "https://w3id.org/SpOTy/ontology#Token",
    "@context": {
      type: {
        "@id": "@type",
        "@isCollection": true,
      },
      ttranscription: {
        "@id": "https://w3id.org/SpOTy/ontology#ttranscription",
        "@type": "http://www.w3.org/2001/XMLSchema#string",
      },
      originalGloss: {
        "@id": "https://w3id.org/SpOTy/ontology#originalGloss",
        "@type": "http://www.w3.org/1999/02/22-rdf-syntax-ns#langString",
      },
      gloss: {
        "@id": "https://w3id.org/SpOTy/ontology#gloss",
        "@type": "http://www.w3.org/1999/02/22-rdf-syntax-ns#langString",
      },
      clause: {
        "@id": "https://w3id.org/SpOTy/ontology#clause",
        "@type": "http://www.w3.org/2001/XMLSchema#integer",
      },
      nextAnnotatedToken: {
        "@id": "https://w3id.org/SpOTy/ontology#nextAnnotatedToken",
        "@type": "@id",
      },
      morphoSyntax: {
        "@id": "https://w3id.org/SpOTy/ontology#morphoSyntax",
        "@type": "@id",
        "@isCollection": true,
      },
      semantics: {
        "@id": "https://w3id.org/SpOTy/ontology#semantics",
        "@type": "@id",
        "@isCollection": true,
      },
      nextToken: {
        "@id": "https://w3id.org/SpOTy/ontology#nextToken",
        "@type": "@id",
      },
      lastToken: {
        "@id": "https://w3id.org/SpOTy/ontology#lastToken",
        "@type": "@id",
      },
    },
  },
  ttranscription: {
    "@id": "https://w3id.org/SpOTy/ontology#ttranscription",
    "@type": "http://www.w3.org/2001/XMLSchema#string",
  },
  originalGloss: {
    "@id": "https://w3id.org/SpOTy/ontology#originalGloss",
    "@type": "http://www.w3.org/1999/02/22-rdf-syntax-ns#langString",
  },
  gloss: {
    "@id": "https://w3id.org/SpOTy/ontology#gloss",
    "@type": "http://www.w3.org/1999/02/22-rdf-syntax-ns#langString",
  },
  clause: {
    "@id": "https://w3id.org/SpOTy/ontology#clause",
    "@type": "http://www.w3.org/2001/XMLSchema#integer",
  },
  nextAnnotatedToken: {
    "@id": "https://w3id.org/SpOTy/ontology#nextAnnotatedToken",
    "@type": "@id",
  },
  morphoSyntax: {
    "@id": "https://w3id.org/SpOTy/ontology#morphoSyntax",
    "@type": "@id",
    "@isCollection": true,
  },
  inScheme: {
    "@id": "http://www.w3.org/2004/02/skos/core#inScheme",
    "@type": "@id",
  },
  broader: {
    "@id": "http://www.w3.org/2004/02/skos/core#broader",
    "@type": "@id",
    "@isCollection": true,
  },
  code: {
    "@id": "https://w3id.org/SpOTy/ontology#code",
    "@type": "http://www.w3.org/2001/XMLSchema#string",
  },
  comment: {
    "@id": "http://www.w3.org/2000/01/rdf-schema#comment",
    "@type": "http://www.w3.org/1999/02/22-rdf-syntax-ns#langString",
  },
  semantics: {
    "@id": "https://w3id.org/SpOTy/ontology#semantics",
    "@type": "@id",
    "@isCollection": true,
  },
  nextToken: {
    "@id": "https://w3id.org/SpOTy/ontology#nextToken",
    "@type": "@id",
  },
  lastToken: {
    "@id": "https://w3id.org/SpOTy/ontology#lastToken",
    "@type": "@id",
  },
  RemoteSentenceCollection: {
    "@id": "https://w3id.org/SpOTy/ontology#RemoteSentenceCollection",
    "@context": {
      type: {
        "@id": "@type",
        "@isCollection": true,
      },
      seeAlso: {
        "@id": "http://www.w3.org/2000/01/rdf-schema#seeAlso",
        "@type": "@id",
      },
    },
  },
  seeAlso: {
    "@id": "http://www.w3.org/2000/01/rdf-schema#seeAlso",
    "@type": "@id",
  },
  UserPreferences: {
    "@id": "https://w3id.org/SpOTy/ontology#UserPreferences",
    "@context": {
      type: {
        "@id": "@type",
        "@isCollection": true,
      },
      value: {
        "@id": "http://www.w3.org/1999/02/22-rdf-syntax-ns#value",
        "@type": "http://www.w3.org/2001/XMLSchema#string",
      },
    },
  },
  value: {
    "@id": "http://www.w3.org/1999/02/22-rdf-syntax-ns#value",
    "@type": "http://www.w3.org/2001/XMLSchema#string",
  },
};
